<template>
  <div class="roles-mobile-container py-2">
    <!-- Mobile Roles List -->
    <div v-if="parentTable.roles && parentTable.roles.length > 0">
      <v-card
        v-for="item in parentTable.roles"
        :key="item._id"
        outlined
        class="role-card mb-4 rounded-xl shadow-sm border border-gray-100 overflow-hidden"
      >
        <!-- Card Header: Role Name -->
        <v-card-text class="pb-2 pt-4 px-4 bg-gray-50 flex justify-between items-center">
          <div class="text-sm font-bold text-gray-800 flex items-center gap-2">
            <v-icon color="primary" small>mdi-shield-account-outline</v-icon>
            {{ item.role }}
          </div>
        </v-card-text>

        <!-- Card Body: Privileges & Permissions Stats -->
        <v-card-text class="px-4 py-3 border-t">
          <div class="flex flex-col gap-3 text-xs">
            <!-- Privileges Count -->
            <div class="flex justify-between items-center py-1">
              <span class="text-gray-500">Privileges</span>
              <span class="font-bold text-gray-700">{{
                parentTable.formatNumber(item.extraPrivileges?.length || 0)
              }}</span>
            </div>

            <!-- Permissions Count -->
            <div class="flex justify-between items-center py-1 border-t border-gray-50">
              <span class="text-gray-500">Permissions</span>
              <span class="font-bold text-gray-700">{{
                parentTable.formatNumber(parentTable.getPermissionCount(item))
              }}</span>
            </div>

            <!-- Module Permissions Count -->
            <div class="flex justify-between items-center py-1 border-t border-gray-50">
              <span class="text-gray-500">Module Permissions</span>
              <span class="font-bold text-gray-700">{{
                parentTable.formatNumber(parentTable.getModulePermissionCount(item))
              }}</span>
            </div>
          </div>
        </v-card-text>

        <!-- Card Footer: Quick Actions -->
        <v-card-actions class="px-4 py-2 bg-gray-50 border-t">
          <!-- Edit IAM policies (JSON) -->
          <v-btn
            outlined
            small
            color="secondary"
            class="rounded-lg font-semibold normal-case text-xs"
            @click.stop="parentTable.$emit('configure-iam', item)"
          >
            <v-icon left size="14">mdi-code-json</v-icon>
            IAM Policies
          </v-btn>

          <!-- Edit & Delete Buttons -->
          <div class="flex items-center justify-end gap-2">
            <v-btn
              v-if="
                parentTable.hasIamPermission(parentTable.iamStatements, 'organization.roles.update')
              "
              small
              depressed
              color="primary"
              class="white--text rounded-lg px-3 font-semibold normal-case text-xs"
              @click.stop="parentTable.editRole(item)"
            >
              <v-icon left size="14">mdi-pencil</v-icon>
              Edit
            </v-btn>

            <v-btn
              v-if="
                parentTable.hasIamPermission(parentTable.iamStatements, 'organization.roles.delete')
              "
              small
              outlined
              color="red"
              class="rounded-lg px-2 text-xs normal-case font-semibold"
              @click.stop="parentTable.deleteRole(item._id)"
            >
              <v-icon size="14">mdi-delete-outline</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>

      <!-- Pagination -->
      <div class="flex justify-center mt-4">
        <v-pagination
          v-model="parentTable.internalOptions.page"
          :length="totalPages"
          total-visible="5"
          :color="$vuetify.theme.currentTheme.primary"
        ></v-pagination>
      </div>
    </div>

    <!-- Loading State -->
    <div v-else-if="parentTable.loadTable" class="text-center py-8">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <!-- No Data -->
    <div v-else class="text-center py-8 text-gray-500">No roles configured.</div>
  </div>
</template>

<script>
export default {
  name: 'PrevilageTable_mobile',
  inject: ['parentTable'],
  computed: {
    totalPages() {
      const limit = this.parentTable.internalOptions.itemsPerPage || 10
      return Math.ceil(this.parentTable.totalRoles / limit) || 1
    }
  }
}
</script>

<style scoped>
.role-card {
  border-radius: 12px !important;
}
</style>
